import React from 'react';
import PropTypes from 'prop-types';
import styles from '../fjord/sectionRubricBlock.scss';
import { t } from '../../../services/i18nService';
import scorableItemReader from '../../../store/readHelpers/ScorableItemReader';
import scorableItemNumberingService from '../../../services/questionView/ScorableItemNumberingService';
import pbStyles from '../../../components/question/paperBasedStyles/ceqPBStyles.scss';
import themeServices from '../../ThemeServices';
import { removeEmptyTagsFromHTMLString } from '../../../loading/utils/richTextUtils';
import settingsReader from '../../../store/readHelpers/SettingsReader';
import sessionReader from '../../../store/readHelpers/SessionReader';

class SectionRubricBlock extends React.PureComponent {
    static propTypes = {
        section: PropTypes.object,
        ui: PropTypes.object,
    };

    returnQuestionRange() {
        const { section, ui } = this.props;
        const { scorableItemsDash = '-' } = ui.variables;
        if (scorableItemReader.useNumberPerInteraction()) {
            const firstQuestionInSection = section?.questions?.[0];
            const lastQuestionInSection = section?.questions?.[section?.questions?.length - 1];
            const firstOrderNumberInSection = scorableItemNumberingService.getFirstValidOrderNumberInQuestion(
                firstQuestionInSection?.contentRevisionId
            );
            const lastOrderNumberInSection = scorableItemNumberingService.getLastValidOrderNumberInQuestion(
                lastQuestionInSection?.contentRevisionId
            );
            if (lastOrderNumberInSection === 1 || firstOrderNumberInSection === lastOrderNumberInSection) {
                return `${firstOrderNumberInSection}`;
            }
            return `${firstOrderNumberInSection}${scorableItemsDash}${lastOrderNumberInSection}`;
        }
        const firstItemNumber = section?.questions?.[0]?.questionNumberingInSection;
        const lastItemNumber = section?.questions?.[section?.questions?.length - 1]?.questionNumberingInSection;
        if (lastItemNumber === 1) {
            return `${firstItemNumber}`;
        }
        return `${firstItemNumber} ${scorableItemsDash} ${lastItemNumber}`;
    }

    returnRubricTitle(section) {
        let sectionNumber = section?.questions?.[0]?.sectionNumber;
        if (sectionNumber === undefined) {
            sectionNumber = 1;
        }
        return (
            <span className={pbStyles.pbBasedSectionTitle}>
                <p>{`${t('rubric.title.part')} ${sectionNumber}`}</p>
            </span>
        );
    }

    returnRubricQuestionPrefix(questionRange) {
        const scorableItemsDash = this.props?.ui?.variables?.scorableItemsDash || '-';
        return questionRange.includes(scorableItemsDash) ? `${t('generic.multipleQuestionsTitle')}` : `${t('generic.questionNumberPrefix')}`;
    }

    returnRubricTitleQuestionRange() {
        const questionPrefix = this.returnRubricQuestionPrefix(this.returnQuestionRange());
        return (

            <span className={`${styles.pbBasedRubricQuestionTitle} ${pbStyles.pbBasedStimulusQuestionTitle}`}>
                <b>{questionPrefix} {this.returnQuestionRange()}</b>
            </span>
        );
    }

    returnRubricInstructions(section) {
        const questionRubricHTML = themeServices.getThemeInstance().getQuestionRubricsContent(section?.questions?.[0], null);
        if (!questionRubricHTML) {
            return null;
        }

        const parsedHtml = removeEmptyTagsFromHTMLString(questionRubricHTML);
        return (
            <div>
                <div
                    id={`sectionRubricInstructions-${section.id}`}
                    className={pbStyles.pbBasedRubricContent}
                    dangerouslySetInnerHTML={{ __html: parsedHtml }}
                />
                <div className={`${pbStyles.pbBasedDrawingSeparator} ${pbStyles.extraSpace}`} />
            </div>
        );
    }

    render() {
        const { section } = this.props;
        const noMarginClassName = settingsReader.isPBRenderForCeqEnabled() && sessionReader.isPrintStylePaperBased()
            ? pbStyles.pbBasedSectionTitleWithNoTopMargin : '';

        return (
            <section
                tabIndex={0}
                aria-labelledby={`sectionRubricTitle-${section.id} sectionRubricInstructions-${section.id}`}
                id="sectionRubric"
            >
                <h3 id={`sectionRubricTitle-${section.id}`} className={noMarginClassName}>
                    {this.returnRubricTitle(section)}
                </h3>

                {this.returnRubricTitleQuestionRange()}
                {this.returnRubricInstructions(section)}
            </section>
        );
    }
}

export default SectionRubricBlock;
